import { buildClassMap } from '../utilities/index';
import { AnimationStyles } from '../styles/index';
/**
 * {@docCategory AnimationClassNames}
 */
export var AnimationClassNames = buildClassMap(AnimationStyles);
//# sourceMappingURL=AnimationClassNames.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@uifabric/styling/lib/classNames/AnimationClassNames.js
// module id = 642
// module chunks = 0